import React from "react";
import "./Benefit.css";
import checkIcon from "../../assets/sec_benefit_sc/icon_check.webp";

const Benefit = () => {
  return (
    <React.Fragment>
      <div className="container-benefit-tc">
        <h1 className="title-benfit-sc">Benefit Program Training Camp</h1>
        <div className="box-benefit-tc">
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Pendampingan intensif baik akademik maupun fisik selama program
            berjalan.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Program belajar terjadwal,terukur dan tertarget.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Sistem belajar yang efektif dengan memprioritaskan fokus belajar
            siswa.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Fasilitas pendukung belajar dan latihan sangat memadai dan lengkap.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Pemantauan perkembangan belajar siswa melalui Tryout berkala.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Berkesempatan dibimbing Tutor dan Pelatih profesional dan
            berpengalaman.
          </span>
          <span className="list-benefit-tc">
            <img src={checkIcon} alt="Les Privat Akpol" className="icon-check" />
            Pola pembinaan dengan metode Holistik baik dari segi
            intelektual,jasmani minat bakat,emosional maupun spiritual.
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Benefit;
